// pricingData.js
export const pricingData = {
  billingCycles: ["monthly", "yearly"],
  defaultCycle: "yearly",
  cycleLabels: {
    monthly: {
      suffix: "/month",
      discountLabel: "",
    },
    yearly: {
      suffix: "/month",
      discountLabel: "20% off (2 months free)",
    },
  },
  plans: {
    free: {
      billingCycles: ["monthly", "yearly"],
      title: "Free",
      price: { monthly: 0, yearly: 0 },
      features: [
        {
          text: "Transcribe your voice in real-time",
          tooltip:
            "Turn your thoughts into move-by-move notes instantly while playing or analyzing games on Lichess.",
        },
        {
          text: "Unlimited cloud transcript storage",
          tooltip:
            "Never lose your notes—store unlimited transcripts securely in the cloud, accessible anytime.",
        },
        {
          text: "Replay your in-game audio per move",
          tooltip:
            "Revisit your exact thoughts during each move. Train smarter by reliving your decision-making process.",
        },
        {
          text: "Public or private transcript sharing",
          tooltip:
            "Publish lessons for the world or keep reflections private. You're always in control.",
        },
        {
          text: "Cross-platform account sync (coming soon)",
          tooltip:
            "Link all your chess activity under one profile (lichess.org, chess.com, FIDE, USCF, ...). A unified system for serious learners.",
        },
      ],
      notes: [],
    },
    premium: {
      title: "Plus",
      price: { monthly: 20, yearly: 16 },
      features: [
        {
          text: "Everything in Free, plus:",
          tooltip:
            "All the great features of the Free plan, plus premium coaching and pro-level tools.",
          bold: true,
        },
        {
          text: "1 annotated game review from a titled player every week",
          tooltip:
            "Each week, submit one of your games to get detailed feedback from FIDE 2000+ titled players in English or Spanish. Think of it as monthly coaching from real pros.",
        },
        {
          text: "1 annotated game review from an expert player every week",
          tooltip:
            "Each week, submit one of your games to get detailed feedback from FIDE 2000+ players in English or Spanish. Think of it as monthly coaching from real pros.",
        },
        {
          text: "4 hours of high-accuracy transcription every week",
          tooltip:
            "Better accuracy for long sessions or analysis-heavy commentary—up to 4 hours of premium transcription weekly.",
        },
        {
          text: "Private transcription sharing with handpicked teammates",
          tooltip:
            "Share your insights from your transcripts privately with students, coaches, or study groups—perfect for collaboration.",
        },
        {
          text: "Unlimited access to our upcoming Chess Language Model (coming soon)",
          tooltip:
            "Be the first to access our powerful AI Chess Language Model for AI Coaching and conversations before anyone else. Unlimited feedback, anytime.",
        },
        {
          text: "Live Weekly Coaching Classes (coming soon)",
          tooltip:
            "Participate in an interactive 12 person group class every week taught by a FIDE 2000+ titled player and .",
        },
      ],
      notes: ["Billed annually"],
    },
  },
};
